import { createClient } from '@supabase/supabase-js';

// Access environment variables using Vite's import.meta.env
// We use optional chaining (?.) to prevent crashes if import.meta.env is undefined
const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL;
const supabaseKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY;

// Create a single supabase client for interacting with your database
// If keys are not present (e.g., local dev without .env), this will be null
// and the app will gracefully fall back to local/mock mode via dataService.ts
export const supabase = (supabaseUrl && supabaseKey) 
  ? createClient(supabaseUrl, supabaseKey) 
  : null;